import formSearchRequest from './components/formSearchRequest/formSearchRequest.vue'
import tablechangedate from './components/tablechangedate/tablechangedate.vue'
import approvedisapprove from './components/approvedisapprove/approvedisapprove.vue'
import ChangedateofinstallmentRepository from '@/shared/http/repositories/realestate/changedateofinstallment'
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'

export default {
  name: 'changedateofinstallment',
  components: {
    tablechangedate,
    formSearchRequest,
    approvedisapprove

  },
  mixins: [ PermisionMixin ],
  data () {
    return {
      dataParcela: null,
      roles: Roles,
      tablereload: 0
    }
  },
  methods: {
    deleteRequest (id) {
      ChangedateofinstallmentRepository.DeleteSolicitacao(id)
        .then(Response => {
          this.dataParcela = Response.data.data
          this.tablereload++
          this.$refs.tableGrid.Delete(Response)
        })
        .catch(() => {})
    },
    GetFilter (filter, isFilter) {
      this.$refs.tableChangeDateComponent.searchWithFilter(filter, isFilter)
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/changedateofinstallment/changedateofinstallment.js